export const TABLE_COLUMN_TYPE_OPTIONS = [
    {
        label: 'tables.basicTypes',
        items: [
            {
                label: 'tables.string',
                value: { type: 'string' }
                // example: '"Hello world"',
                // description: 'Any text value'
            },
            {
                label: 'tables.number',
                value: { type: 'number' }
                // example: '3.14159',
                // description: 'Decimal or integer values'
            },
            {
                label: 'tables.integer',
                value: { type: 'integer' }
                // example: '42',
                // description: 'Whole numbers only'
            },
            {
                label: 'tables.boolean',
                value: { type: 'boolean' }
                // example: 'true/false',
                // description: 'True or false values'
            }
        ]
    },
    {
        label: 'tables.dateTypes',
        items: [
            {
                label: 'tables.date',
                value: { type: 'string', format: 'date' }
            },
            {
                label: 'tables.iso-date-time',
                value: { type: 'string', format: 'iso-date-time' }
                // example: '2024-02-03T15:30:00Z',
                // description: 'Full date and time with timezone'
            },
            {
                label: 'tables.m3-date',
                value: { type: 'string', format: 'm3-date' }
                // example: 'YYYYMMDD',
                // description: 'M3 format date (e.g. 240203)'
            }
        ]
    },
    {
        label: 'tables.specialTypes',
        items: [
            {
                label: 'tables.compute-expression',
                value: { type: 'string', format: 'compute-expression' }
                // example: 'firstname & " " & lastname',
                // description: 'Computed value from other fields'
            }
        ]
    },
    {
        label: 'tables.otherTypes',
        items: [
            {
                label: 'tables.object',
                value: { type: 'object' }
                // example: '{ "key": "value" }',
            },
            {
                label: 'tables.array',
                value: { type: 'array', items: { type: 'any' } }
                // example: '[ "item1", "item2" ]',
            },
            {
                label: 'tables.email', 
                value: { type: 'string', format: 'email' }
                // example: 'user@example.com',
                // description: 'Valid email address'
            },
            {
                label: 'tables.uuid',
                value: { type: 'string', format: 'uuid' }
                // example: '123e4567-e89b-12d3-a456-426614174000',
                // description: 'Universally unique identifier'
            },
            {
                label: 'tables.ipv4',
                value: { type: 'string', format: 'ipv4' }
                // example: '192.168.1.1',
                // description: 'IPv4 address'
            }
        ]
    }
];

export const SYSTEM_FIELDS = ['__id', '__created', '__modified', '__modifiedBy', '__createdBy'];
export const SYSTEM_FIELDS_PREFIXES = ['x4_'];

export const COMPUTE_EXPRESSION = 'compute-expression';

export const INFERENCE_VERIFY_THRESHOLD = 0.9;
export const INFERENCE_PROBABLY_WRONG_THRESHOLD = 0.5;
